import { useAppSelector } from 'app/hooks';
import { isDuctedOnlySystemPreference } from 'utils/project';

// The STRICT ducted commitment (AHA-6681 tonnage §F): 'Help Me Decide'
// never counts, so the size skip and its footer are never offered there.
export default function useIsDuctedOnlyPathway(): boolean {
  return useAppSelector((state) =>
    isDuctedOnlySystemPreference(
      state.project.projectSettings.find(
        (ps) => ps.code === 'system_preference'
      )?.value
    )
  );
}
